module.exports = __webpack_public_path__ + "assets/images/mega_news.67766dc80caf6c17eb535b91eaa42b14.png";